import mlogo1 from "../images/sm/logo_m2__small.png";
import mlogo2 from "../images/md/m2_logo_medium.png";
import mlogo3 from "../images/lg/m2_logo_large.png";
import "./Watch.css";

function Watch() {
    return (
        <section className="watch-ipadpro">
            <div className="container-fluid">
                <div className="row">
                    <div className="watchs-wrapper col-md-6 left">
                        <div className="watch cursorP">
                            <div className="watch-logo mb-2"></div>
                            <div>A healthy leap ahead.</div>
                            <div className="links-blue">
                                <ul className="list-inline iphoneproa">
                                    <li className="list-inline-item">
                                        <a href="">Learn more</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="">Buy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="ipadpro-wrapper col-md-6 right">
                        <div className="ipadpro-right cursorP">
                            <div className="name3">iPad Pro</div>
                            <div className="list-inline">
                                <div className="list-inline-item name2 me-0">
                                    Supercharged by
                                </div>
                                <div className="mlogo list-inline-item d-md-none d-lg-none">
                                    <img src={mlogo1} />
                                </div>
                                <div className="mlogo list-inline-item d-none d-md-inline d-lg-none">
                                    <img src={mlogo2} />
                                </div>
                                <div className="mlogo list-inline-item d-none d-lg-inline">
                                    <img src={mlogo3} />
                                </div>
                            </div>
                            <div className="links-blue">
                                <ul className="list-inline iphoneproa">
                                    <li className="list-inline-item">
                                        <a href="">Learn more</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="">Buy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Watch;
